export function mapLoader() {
	const lazyFrames = document.querySelectorAll('iframe[data-src]');
	lazyFrames.forEach((iframe) => {
		iframe.setAttribute('src', iframe.getAttribute('data-src'));
		iframe.removeAttribute('data-src');
	});
}
